import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import api, { formatDate } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Gauge, Printer, Loader2 } from "lucide-react";

export default function EquipmentLabel() {
  const { id } = useParams();
  const [equipment, setEquipment] = useState(null);
  const [qr, setQr] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    Promise.all([api.get(`/equipment/${id}`), api.get(`/equipment/${id}/qr`)])
      .then(([eq, qrRes]) => {
        setEquipment(eq.data);
        setQr(qrRes.data);
      })
      .catch(() => setError("Equipment not found or access denied."));
  }, [id]);

  if (error) return <div className="p-10 text-center text-sm text-red-500" data-testid="label-error">{error}</div>;
  if (!equipment || !qr) return <div className="p-10 text-center"><Loader2 className="mx-auto h-6 w-6 animate-spin" /></div>;

  return (
    <div className="flex min-h-screen flex-col items-center bg-slate-100 py-10" data-testid="equipment-label-page">
      <div className="no-print mb-6 flex items-center gap-4">
        <span className="text-sm text-slate-600">Asset label — {equipment.work_order_no}</span>
        <Button size="sm" onClick={() => window.print()} data-testid="print-qr-label-button">
          <Printer className="mr-2 h-4 w-4" /> Print Label
        </Button>
      </div>
      <div className="flex w-[340px] gap-4 border-2 border-slate-900 bg-white p-4 text-slate-900" data-testid="asset-label">
        <img src={qr.qr_base64} alt="QR code" className="h-28 w-28 shrink-0" />
        <div className="min-w-0">
          <div className="flex items-center gap-1.5">
            <Gauge className="h-4 w-4" />
            <span className="font-display text-sm font-bold">BMDLabsystem</span>
          </div>
          <div className="mt-1 font-mono text-lg font-bold tracking-tight">{equipment.work_order_no}</div>
          <div className="mt-1 truncate text-sm font-medium">{equipment.name}</div>
          <div className="truncate text-xs text-slate-600">{[equipment.manufacturer, equipment.model].filter(Boolean).join(" / ")}</div>
          <div className="mt-1 font-mono text-[10px] text-slate-500">SN: {equipment.serial_number}</div>
          <div className="font-mono text-[10px] text-slate-500">Received: {formatDate(equipment.received_date)}</div>
          <div className="mt-1.5 border-t border-dashed border-slate-400 pt-1 font-mono text-[9px] uppercase tracking-widest text-slate-400">
            Scan for tracking · ISO/IEC 17025
          </div>
        </div>
      </div>
    </div>
  );
}
